import React from 'react'
import T from 'prop-types'
import { InputLabel as MuiInputLabel } from '@mui/material'

export default function InputLabel({ label, inputId, inputLabelProps, sx }) {
  return (
    <MuiInputLabel
      {...inputLabelProps}
      htmlFor={inputId}
      sx={{ typography: 'body2', fontWeight: 'fontWeightBold', ...sx }}
    >
      {label}
    </MuiInputLabel>
  )
}

InputLabel.propTypes = {
  label: T.string,
  inputId: T.string,
  inputLabelProps: T.object,
  sx: T.object,
}
